
export class OrderModalController {
    private static _instance: OrderModalController;
    private readonly scopes: NodeListOf<HTMLElement>;

    private constructor() {
        this.scopes = document.querySelectorAll('.scope-dlp') as NodeListOf<HTMLElement>;

        if(!this.scopes) {
            return;
        }

        this.initOrderModalUrl();
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    private initOrderModalUrl() : void {
        const scopesArray: Array<HTMLElement> = Array.prototype.slice.call(this.scopes);

        for (const scope of scopesArray){
            const btnList: NodeListOf<HTMLElement> = scope.querySelectorAll('.order-modal-btn') as NodeListOf<HTMLElement>;

            const btnArray: Array<HTMLElement> = Array.prototype.slice.call(btnList);

            for (const btn of btnArray) {
                const magicLink = btn.getAttribute('data-order-modal-magic-link');
                btn.addEventListener('click',() => { 
                    window.shell.publishTo('ESPP.OrderModal.MagicLink.Open', { magicLink: 'article://' + magicLink });
                });
            }
        }
    }
}

OrderModalController.instance;